import { Button, Flex } from 'components';
import './style.scss';
import { monthToString } from 'common/helpers';

interface IProps {
  date: Date;
  minDate: Date;
  onSelect: (date: Date) => void;
}

function StageMonth(props: IProps) {
  const minYear = props.minDate.getFullYear();
  const maxYear = props.minDate.getFullYear() + 2;

  const getMonthButtons = (): React.ReactNode[] => {
    const monthButtons: React.ReactNode[] = [];

    for (let year = minYear; year <= maxYear; year++) {
      for (let month = 0; month < 12; month++) {
        if (year === minYear && month < props.minDate.getMonth()) {
          continue;
        }

        const monthButton = (
          <StageMonthButton
            key={`${year}_${month}`}
            year={year}
            month={month}
            current={props.date}
            onClick={() => handleMonthClick(year, month)}
          />
        );

        monthButtons.push(monthButton);
      }
    }

    return monthButtons;
  };

  const handleMonthClick = (year: number, month: number) => {
    props.onSelect(new Date(year, month, props.date.getDate()));
  };

  return (
    <div className='month-list-99Q1'>
      <Flex
        className='month-scroll-DFIn'
        direction='column'
        gap={5}
      >
        {getMonthButtons()}
      </Flex>
    </div>
  );
}

interface IStageMonthButtonProps {
  year: number;
  month: number;
  current: Date;
  onClick: () => void;
}

function StageMonthButton(props: IStageMonthButtonProps) {
  const color =
    props.current.getFullYear() === props.year && props.current.getMonth() === props.month
      ? 'blue'
      : 'transparent-blue';

  return (
    <Button
      color={color}
      onClick={props.onClick}
    >
      {props.year} — {monthToString(props.month)}
    </Button>
  );
}

export default StageMonth;
